import React from 'react';

export interface SegmentedToggleProps {
  value: boolean; // true = left option active, false = right
  onChange: (next: boolean) => void;
  leftLabel: string;
  rightLabel: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  size?: 'sm' | 'md';
  ariaLabel?: string;
}

/** Two-option sliding segmented toggle (accessible, animated) */
export default function SegmentedToggle({
  value,
  onChange,
  leftLabel,
  rightLabel,
  leftIcon,
  rightIcon,
  size = 'md',
  ariaLabel,
}: SegmentedToggleProps) {
  const cls = `segmented-toggle ${value ? 'is-left' : 'is-right'} ${size}`;
  return (
    <div className={cls} role="tablist" aria-label={ariaLabel || 'Toggle'}>
      <div className="segmented-thumb" aria-hidden="true" />
      <button
        type="button"
        role="tab"
        aria-selected={value}
        className={`segmented-option ${value ? 'active' : ''}`}
        onClick={() => onChange(true)}
      >
        {leftIcon && <span className="segmented-icon" aria-hidden>{leftIcon}</span>}
        <span className="segmented-label">{leftLabel}</span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={!value}
        className={`segmented-option ${!value ? 'active' : ''}`}
        onClick={() => onChange(false)}
      >
        {rightIcon && <span className="segmented-icon" aria-hidden>{rightIcon}</span>}
        <span className="segmented-label">{rightLabel}</span>
      </button>
    </div>
  );
}

